import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import Table from './Table';

export default function Jobs() {
  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Jobs'}]}/>
      <Paper>
        <Table/>
      </Paper>
    </div>
  );
}
